require('../../modules/es.string.iterator');

require('../../modules/es.array.from');

var path = require('../../internals/path');

module.exports = path.Array.from;